import React, { useEffect, useState } from 'react';
import { useGetTariffPrices } from '../hooks/api/contractsApi';
import { useParams } from 'react-router';
import { tariffsColumns } from '../enums/columns';
import { getMonthName } from '../../../utils/date';
import { FormattedMessage, useIntl } from 'react-intl';
import capitalize from '@material-ui/core/utils/capitalize';
import DataTable from '../../../components/DataTable/DataTable';
import SectionHeader from '../../../components/SectionHeader/SectionHeader';
import CardRow from '../../../components/CardRow/CardRow';
import CardRowCard from '../../../components/CardRow/CardRowCard';
import FileExport from '../../../components/FileExport/FileExport';
import DataTableBodyCellDecimal from '../../../components/DataTable/DataTableBody/DataTableBodyCell/DataTableBodyCellDecimal';
import { useGetContractTariffPricesExport } from '../hooks/api/contractsApi';

const getMonthNameByMonthNumber = (intl, month) => {
  return getMonthName(intl, new Date(2000, month - 1, 1));
};

const initialValues = {
  order: 'asc',
  orderBy: 'tariff',
};

let columns = [];

const TariffPrices = () => {
  const intl = useIntl();
  const [tableData, setTableData] = useState([]);
  const [orderDirection, setOrderDirection] = useState(initialValues.order);
  const [orderByColumn, setOrderByColumn] = useState(initialValues.orderBy);
  const { contractId } = useParams();
  const { getTariffPrices, data, loading, error } = useGetTariffPrices();
  const [currency, setCurrency] = useState('');
  const { getContractTariffPricesExport, data: exportData, error: exportError } = useGetContractTariffPricesExport();

  useEffect(() => {
    columns = [tariffsColumns.tariff];
    for (let i = 1; i <= 12; i++) {
      const column = {
        id: `month_${i}`,
        label: `${capitalize(getMonthNameByMonthNumber(intl, i))}`,
        width: '8%',
        align: 'right',
      };
      columns.push(column);
    }
  }, [intl]);

  useEffect(() => {
    const query = {
      order: orderDirection,
      orderBy: orderByColumn,
    };
    (async () => {
      await getTariffPrices(contractId, query);
    })();
  }, [getTariffPrices, orderDirection, orderByColumn, contractId]);

  useEffect(() => {
    if (data) {
      data?.[0]?.currency?.id && setCurrency(data[0].currency.id);
      setTableData(
        data.map((line) => {
          const output = {
            tariff: (
              <>
                <FormattedMessage id={'app.contract.tariff'} /> {line.idTariff}
              </>
            ),
          };
          line.prices.forEach((month) => {
            output[`month_${month.month}`] = <DataTableBodyCellDecimal value={month.price} />;
          });
          return output;
        }),
      );
    }
  }, [data]);

  return (
    <>
      <SectionHeader>
        <FormattedMessage id="app.contract.priceMWHCurrency" values={{ currency: currency }} />
        <FileExport
          getAllEntityExport={getContractTariffPricesExport}
          tooltip={<FormattedMessage id="app.contract.priceMWHCurrency.export" values={{ currency: currency }} />}
          fileName={intl.formatMessage({ id: 'app.contract.priceMWHCurrency.export.filename' }, { contractId: contractId })}
          data={exportData}
          searchQuery={contractId}
          exportError={exportError}
          key={'toolbar-file-export'}
        />
      </SectionHeader>
      <CardRow>
        <CardRowCard>
          <DataTable
            displayToolbar={false}
            displayPagination={false}
            lineHover
            columns={columns}
            data={tableData || []}
            loading={loading}
            error={error}
            orderDirection={orderDirection}
            setOrderDirection={setOrderDirection}
            orderByColumn={orderByColumn}
            setOrderByColumn={setOrderByColumn}
          />
        </CardRowCard>
      </CardRow>
    </>
  );
};

export default TariffPrices;
